export default __webpack_public_path__ + "static/media/betprofessorBg.f8fc5516.png";